export default {
  options (state, getters, rootState) {
    return state.dataOptions.filter(({deleted}) => deleted !== 1)
  },
  optionTypes (state, getters, rootState) {
    return state.dataOptionTypes
  },
  brandGroups (state) {
    return state.brandGroups
  },
  chargeProfiles (state) {
    return state.chargeProfiles.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
    })
  },
  currencies (state, getters, rootState) {
    const arr = state.currencies.slice(0)
    const ret = arr.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
    })
    return ret.filter(({deleted}) => deleted !== 1)
  },
  countries (state, getters, rootState) {
    const arr = state.countries.slice(0)
    const ret = arr.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
    })
    return ret.filter(({deleted}) => deleted !== 1)
  },
  exRates (state, getters, rootState) {
    return state.exchangeRates
  },
  financialCodes (state, getters, rootState) {
    return state.financialCodes
  },
  isSystemParameterEnabled (state) {
    const params = state.dataOptions.filter(({deleted, optionType}) => {
      return deleted !== 1 &&
        optionType !== null && optionType.hasOwnProperty('code') && optionType.code === 'PARAMETER'
    }) || []
    return parameterCode => params.some(param => {
      return param.code === parameterCode && param.valueBoolean === 1
    })
  },
  defaultOption (state) {
    const params = state.dataOptions.filter(({deleted, optionType}) => {
      return deleted !== 1 &&
        optionType !== null && optionType.hasOwnProperty('code') && optionType.code === 'DEFAULT'
    }) || []
    return optionCode => params.find(param => {
      return param.code === optionCode
    })
  },
  defaultEnabled (state) {
    const params = state.dataOptions.filter(({deleted, optionType}) => {
      return deleted !== 1 &&
        optionType !== null && optionType.hasOwnProperty('code') && optionType.code === 'DEFAULT'
    }) || []
    return optionCode => params.find(param => {
      return param.code === optionCode && param.valueBoolean === 1
    })
  },
  jobStatuses (state) {
    return state.dataOptions.filter(({deleted, optionType}) => {
      return deleted !== 1 && optionType !== null && optionType.hasOwnProperty('code') && optionType.code === 'JOB_STATUS'
    }) || []
  },
  jobTypes (state, getters, rootState) {
    return state.jobTypes
  },
  lineDescriptorProperty (state, getters, rootState) {
    const lines = state.lineDescriptorProperty
    return lines ? lines.sort((a, b) => { return a < b ? -1 : a > b ? 1 : 0 }) : []
  },
  noteDescriptorProperty (state, getters, rootState) {
    return state.noteDescriptorProperty
  },
  roles (state, getters, rootState) {
    return state.roles
  },
  partyGroups (state, getters, rootState) {
    return state.partyGroups
  },
  portAreas (state, getters, rootState) {
    return state.portAreas
  },
  serviceTypes (state, getters, rootState) {
    return state.serviceTypes
  },
  staticDescriptorProperty (state, getters, rootState) {
    return state.staticDescriptorProperty
  },
  tariffDescriptorProperty (state, getters, rootState) {
    return state.tariffDescriptorProperty
  },
  userGroups (state, getters, rootState) {
    return state.userGroups
  }
}



// WEBPACK FOOTER //
// ./src/modules/systemoptions/store/getters.js